import { PageHeader } from '@/components/layout/PageHeader';

interface CrmWorkspacePageProps {
  title: string;
  description: string;
}

export function CrmWorkspacePage({ title, description }: CrmWorkspacePageProps) {
  return (
    <div>
      <PageHeader
        title={title}
        description={description}
        breadcrumbs={[{ label: 'Org', to: '/org' }, { label: 'CRM', to: '/crm' }, { label: title }]}
      />
      <div className="card p-6">
        <p className="text-sm text-slate-600 dark:text-slate-300">
          This workspace is provisioned for enterprise CRM and wired to subscription-based feature access.
        </p>
      </div>
    </div>
  );
}
